"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _index = _interopRequireDefault(require("@/store/index"));
var getters = {
  tabRoutes: function tabRoutes(state) {
    return state.permission.tabRoutes;
  },
  // 左侧菜单
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  // 左侧菜单
  language: function language(state) {
    return state.app.language;
  },
  // 语言
  size: function size(state) {
    return state.app.size;
  },
  // 字体大小
  device: function device(state) {
    return state.app.device;
  },
  // 平台 pc或mobile
  commonQueryParams: function commonQueryParams(state) {
    return state.app.commonQueryParams;
  },
  // 公共查询条件
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  // tagView
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  // 缓存 tagView
  token: function token(state) {
    return state.user.token;
  },
  // token 信息
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  // 头像--暂不用
  name: function name(state) {
    return state.user.name;
  },
  // name --暂不用
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  // 介绍 --暂不用
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  // 可访问的路由
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  // 错误信息
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  // 当前登录用户信息
  roles: function roles(state) {
    return state.user.roles;
  },
  // 角色
  desktopConfig: function desktopConfig(state) {
    return state.desktopConfig.config;
  },
  // 个人工作台配置
  isShowPassword: function isShowPassword(state) {
    return state.desktopConfig.isShowPassword;
  },
  // 是否显示密码修改框
  isMustModify: function isMustModify(state) {
    return state.desktopConfig.isMustModify;
  },
  // 是否必须修改密码
  tagBgColor: function tagBgColor(state) {
    return state.app.tagBgColor;
  },
  // 获取标签颜色
  version: function version(state) {
    return state.app.version;
  },
  // 获取标签颜色
  btnPermissions: function btnPermissions(state) {
    return state.user.btnPermissions;
  },
  // 获取按钮权限
  InputChineseCompanyConfig: function InputChineseCompanyConfig(state) {
    return state.app.InputChineseCompanyConfig;
  },
  // 获取控件是否不允许输入中文字符公司判断数据字典
  invalidInputChineseMenuConfig: function invalidInputChineseMenuConfig(state) {
    return state.app.invalidInputChineseMenuConfig;
  },
  // 获取控件是否不允许输入中文字符菜单判断数据字典
  isToastSave: function isToastSave(state) {
    return state.isSaveTip.isToastSave;
  },
  // 是否是订舱页面，阻止关闭显示提示框进行保存
  isToastSavePath: function isToastSavePath(state) {
    return state.isSaveTip.isToastSavePath;
  },
  // 是否是订舱页面，阻止关闭显示提示框进行保存,存得路径
  checkQuery: function checkQuery(state) {
    return state.isSaveTip.checkQuery;
  } //是否需要通告展示
};
var _default = exports.default = getters;